import {
    FETCH_EVALUATIONTYPES_FAILURE,
    FETCH_EVALUATIONTYPES_REQUEST,
    FETCH_EVALUATIONTYPES_SUCCESS
} from "./evaluationTypeTypes"

const initialState = {
    loading: false,
    evaluationTypes: [],
    error: ''
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EVALUATIONTYPES_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case FETCH_EVALUATIONTYPES_SUCCESS:
            return {
                loading: false,
                evaluationTypes: action.payload,
                error: '',
            }
        case FETCH_EVALUATIONTYPES_FAILURE:
            return {
                loading: false,
                evaluationTypes: [],
                error: action.payload
            }
        default: return state;
    }
}
export default reducer;